module.exports = __webpack_public_path__ + "media/student_v2/assets/images/pencil-ffdd6b2e97b7f413abf6700f22f14b73.svg";